import { Alert, Card, Container, Spinner } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import ClaudeCodeLoginGate from '../../components/claude-code/ClaudeCodeLoginGate';
import { HelpLabel } from '../../components/claude-code/HelpTooltip';
import SessionEventTimeline from '../../components/claude-code/SessionEventTimeline';
import { ROUTES } from '../../routes/routes';
import { useSessionEvents } from '../../apps/apis/claudeCodeDashboard/hooks';

const DEFAULT_EVENT_LIMIT = 500;

const ClaudeCodeSessionDetailPage = () => {
  const params = useParams<{ sessionId: string }>();
  const sessionId = params.sessionId ?? '';
  return (
    <ClaudeCodeLoginGate>
      {(session) => (
        <Container fluid className="py-4">
          <div className="mb-3">
            <Link to={ROUTES.agentTelemetry.overview} className="small text-muted">
              ← Overview
            </Link>
            <h2 className="mb-1 mt-1 text-monospace fs-4">{sessionId}</h2>
            <div className="text-muted small">
              Viewing as <strong>{session.email}</strong>
              {session.isAdmin ? <span className="ms-2 badge bg-primary">admin</span> : null}
            </div>
          </div>
          <SessionEvents sessionId={sessionId} />
        </Container>
      )}
    </ClaudeCodeLoginGate>
  );
};

const SessionEvents = ({ sessionId }: { sessionId: string }) => {
  const { data, isLoading, error } = useSessionEvents(sessionId, DEFAULT_EVENT_LIMIT);
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <Spinner animation="border" />
      </div>
    );
  }
  if (error) {
    return <Alert variant="danger">Failed to load events: {(error as Error).message}</Alert>;
  }
  if (!data) {
    return null;
  }
  return (
    <Card>
      <Card.Body>
        <Card.Title className="h6">
          <HelpLabel description="Ordered hook and lifecycle events for this session. Raw prompts and outputs are not shown.">
            Event timeline ({data.events.length})
          </HelpLabel>
        </Card.Title>
        <SessionEventTimeline events={data.events} />
      </Card.Body>
    </Card>
  );
};

export default ClaudeCodeSessionDetailPage;
